angular.module('blacklistAdd', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate', 'ngFileUpload']);



// WEBPACK FOOTER //
// ./src/app/blacklist-add/blacklist-add.module.js